export default __webpack_public_path__ + "static/media/iconCreateCampains.26f639a4.svg";